import React, { useState } from "react";
import axios from "axios";
import { Box, Button } from "@mui/material";
import socket from "../../utils/socket";
import { useSelector } from 'react-redux';
import { useAppDispatch } from "../../redux/store";
import { createEngagement } from "../../redux/actions/engagementActions";
import imageCompression from 'browser-image-compression';


 
const REACT_APP_CHATCON_URL = process.env.REACT_APP_CHATCON_URL;

interface FileUploadProps {
    onFileSelect?: (file: File | null) => void;
}

const FileUpload: React.FC<FileUploadProps> = ({ onFileSelect }) => {
  //@ts-ignore
  const { user } = useSelector(state=>state);
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploadedUrl, setUploadedUrl] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [uploadedFileName, setUploadedFileName] = useState("");
  let avayaPayload = '';
  let avayaImageName ='';

  //@ts-ignore

  const handleFileChange = async (event) => {
    const selectedFile = event.target.files[0];

    const fileType = selectedFile.type;
    console.log("fileTypeeeeee", fileType);
    console.log('originalFile instanceof Blob', selectedFile instanceof Blob); // true
    console.log(`originalFile size ${selectedFile.size / 1024 / 1024} MB`);
    if (selectedFile) {

      const fileType = selectedFile.type;
      if (!(fileType.includes('image/') || fileType === 'application/pdf')) {
        setErrorMessage("Please upload image or PDF files only");
        return;
      }
      const options = {
        maxSizeMB: 5,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
      }

      try {
        let processedFile;
      
        if (fileType.includes('image/')) {
          // Compress the image
          const compressedFile = await imageCompression(selectedFile, options);
          console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
          console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`);
      
          // Convert Blob to File
          processedFile = new File([compressedFile], selectedFile.name, {
            type: compressedFile.type,
            lastModified: Date.now(),
          });
          //@ts-ignore
          setPreview(URL.createObjectURL(processedFile));
        } else if (fileType === 'application/pdf') {
          // No compression for PDFs, use as is
          processedFile = selectedFile;
          setPreview(null);

        } else {
          setErrorMessage("Unsupported file type");
          return;
        }
      
        // Check file size (limit: 50MB)
        if (processedFile.size >= 20000000) {
          setErrorMessage(`Your file is ${processedFile.size / 1024 / 1024} MB. Please upload a smaller file.`);
          return;
        }
      
        setErrorMessage("");
        setFile(processedFile);
        console.log("selectedFile: ", selectedFile);
        console.log("processedFile: ", processedFile);
      
      } catch (error) {
        console.error(error);
        setErrorMessage("An error occurred while processing your file.");
      }      
    }
  };


  const dispatch = useAppDispatch();
  const sendRichMessage = () => {
    
    const richMedia = {
      selectedAction: {
        type: "reply",
        payload: 'I_M_A_G_E_I_D_' + avayaPayload,
      },
    };

    const body = {
      elementType: "reply",
      elementText: {
        text: avayaImageName,
        textFormat: "PLAINTEXT",
      },
      payload: 'I_M_A_G_E_I_D_' + avayaPayload,
      richMediaPayload: richMedia,
    };

    let providerDialogId;

    if (user.user.engagementParameters.CustomerVerified === "true") {
      providerDialogId =
        user.user.chProviderDialogId !== undefined
          ? user.user.chProviderDialogId
          : user.user.providerDialogId;
    } else {
      providerDialogId = user.user.providerDialogId;
    }

    let providerSenderId;

    if (user.user.engagementParameters.CustomerVerified === "true") {
      providerSenderId = user.user.chProviderSenderId !== undefined 
        ? user.user.chProviderSenderId 
        : user.user.providerSenderId;
    } else {
      providerSenderId = user.user.providerSenderId;
    }

    const message = {
      body,
      senderName: user?.user?.displayName || "default", 
      providerDialogId,
      providerSenderId,
      engagementParam: user.user.engagementParameters,
      customerIdentifiers: user.user.customerIdentifiers,
    };

    const s = socket.getInstance();
    s.emit("message", message, (res: any) => {
      if (res.hasError) {
        console.error(res);
      }
    });
    dispatch(createEngagement({ payload: "test" }));
  };

  const handleUpload = async () => {
    if (!file) return alert("Please select a file first");
    const formData = new FormData();
    formData.append("image", file);
    formData.append('providerDialogId', '');
    formData.append('providerSenderId', '');
    formData.append('engagementParam',JSON.stringify(user.user.engagementParameters) );
    formData.append('customerIdentifiers',JSON.stringify( user.user.customerIdentifiers));
    try {
      const response = await axios.post(`${REACT_APP_CHATCON_URL}/image-upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setUploadedUrl(response.data.result.attachments[0].url);
      setUploadedFileName(response.data.result.attachments[0].name);
      avayaPayload = response.data.result.attachments[0].attachmentId;
      avayaImageName = response.data.result.attachments[0].name;
      console.log(uploadedFileName);
      sendRichMessage();
      console.log(response.data.result.attachments[0].name);
    } catch (error) {
      console.error("Upload error:", error);
        //@ts-ignore
        setErrorMessage(error);
    }
  };
  return (
    <Box className="upload-interface" sx={{ display: "flex", flexDirection: "column" }}>
      {
        !uploadedUrl ? 
          <>
          <input type="file" accept="image/*, application/pdf" onChange={handleFileChange} />
          {preview && <img src={preview} alt="Preview" style={{ width: "100%", margin: "15px 0" }} />}
          <Button className="dafabet"
          onClick={handleUpload}
          sx={{
            borderRadius: "14px",
            padding: "0.3rem 2rem",
            margin: "1.5rem 0 0.7rem 0",
            backgroundColor: "#af0000",
            color: "#fff",
            textTransform:"capitalize",
            "&:hover": {
              backgroundColor: "#ffe000",
              color: "#000",
            },
          }}>Submit
          </Button>
          </> : ""}
        {
          errorMessage ? 
          <>
          <h3 style={{ color: "red" }}>Upload failed due to following error:</h3>
          <p  style={{ fontWeight: "bold", color: "red" }}>{errorMessage}</p>
          </> : ""
        }
      {uploadedUrl && (
        <div>
          <p  style={{ fontWeight: "bold", color: "green" }}>You have successfully uploaded file</p>
          { preview && <img src={uploadedUrl} alt="Uploaded" style={{ width: "100%", marginTop: "10px" }} />}
        </div>
      )}
    </Box>
  );
};
export default FileUpload;
